import React from "react";
import { render } from "react-dom";
import App from "./App";

const lmsButtons = document.querySelectorAll(".lms-trigger-button");
if (lmsButtons) {
  lmsButtons.forEach(container => {
    const id = container.getAttribute("data-id");
    const name = container.getAttribute("data-name");
    const type = container.getAttribute("data-type");
    const autoPop = container.getAttribute("data-pop");
    render(
      <App id={id} name={name} type={type} autoPop={autoPop} />,
      container
    );
  });
}
